import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Tag from "@insite/mobius/Icons/Tag";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

wishListCardStyles.gridContainer = {
    gap: 5,
    css: css`
        border-bottom: 1px solid ${getColor("common.border")};
        padding-bottom: 15px;
    `,
};

wishListCardStyles.actionAddToCartButton = {
    mergeCss: true,
    color: "secondary",
    css: css`
        white-space: nowrap;
        width: 100%;
        padding: 0 10px;
    `, // keep text from wrapping
};

wishListCardStyles.actionOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            span {
                color: #ffffff !important;
            }
            ul {
                background: #ffffff;
            }
        `,
    },
};

wishListCardStyles.sharingStatus = {
    privateTooltip: {
        cssOverrides: {
            tooltipBody: css`
                color: #ffffff !important;
            `,
            tooltipContainer: css`
                margin-left: -50px !important;
                &::after {
                    left: 22% !important;
                }
            `,
        },
    },
};

wishListCardStyles.actionDeleteButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 10px;
    `,
};

wishListCardStyles.actionLeaveButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 10px;
    `,
};

wishListCardStyles.sharingStatusGridItem = {
    width: [12, 12, 12, 4, 4],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    flex-basis: 31.333%;
                    max-width: 31.333%;
                `,
                css`
                    flex-basis: 31.333%;
                    max-width: 31.333%;
                `,
            ])}
    `,
};

wishListCardStyles.tagTooltip = {
    iconProps: {
        src: Tag,
        size: 15,
        css: css`
            margin: 4px 0;
        `,
    },
    cssOverrides: {
        tooltipBody: css`
            color: #ffffff !important;
        `,
    },
};
